/** Which OS-level modifier key a keyboard-shortcut hint should NAME, as
 *  distinct from which key actually TRIGGERS it. Handlers already accept
 *  either (`e.metaKey || e.ctrlKey`) so Cmd and Ctrl both work everywhere —
 *  this only decides what the UI shows, since this is browser software that
 *  runs on Windows/Linux/Android as much as macOS, and a hint that always
 *  said "Cmd" would be wrong for most of that install base. */

/** Browser-only signal (navigator), guarded for non-browser test/SSR
 *  environments. userAgentData.platform is the modern, spoof-resistant
 *  source where available (Chromium); navigator.platform is the fallback
 *  everywhere else, including Safari/Firefox. */
export function isApplePlatform(): boolean {
  if (typeof navigator === 'undefined') return false;
  const platform = (navigator as { userAgentData?: { platform?: string } }).userAgentData?.platform
    ?? navigator.platform
    ?? navigator.userAgent
    ?? '';
  return /Mac|iPhone|iPad|iPod/i.test(platform);
}

/** "⌘" on macOS/iOS/iPadOS, "Ctrl" on Windows, Linux and Android web. */
export function primaryModifierKeyLabel(): string {
  return isApplePlatform() ? '⌘' : 'Ctrl';
}
